/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Hero_Cta_EditorInputs */

const en_pc_hero_cta_editor = /** @type {(inputs: Pc_Hero_Cta_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start editing, it's free`)
};

const zh_pc_hero_cta_editor = /** @type {(inputs: Pc_Hero_Cta_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线编辑`)
};

/**
* | output |
* | --- |
* | "Start editing, it's free" |
*
* @param {Pc_Hero_Cta_EditorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_hero_cta_editor = /** @type {((inputs?: Pc_Hero_Cta_EditorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Hero_Cta_EditorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_hero_cta_editor(inputs)
	return zh_pc_hero_cta_editor(inputs)
});
export { pc_hero_cta_editor as "pc.hero.cta_editor" }